import React, {lazy} from 'react';
import {Route, Switch, useLocation,Redirect} from 'react-router-dom';
import MinimalLayout from '../layout/MinimalLayout';
import NavMotion from '../layout/NavMotion';


const AuthLogin = lazy(() => import('../views/pages/authentication/login/FormLogin'));

const LoginRoutes = () => {
    const location = useLocation();

    return (
        <Route exact path={'/login'}>
            <MinimalLayout>
                <Switch location={location} key={location.pathname}>
                    <NavMotion>

                            <AuthLogin/>
                           
                    </NavMotion>
                </Switch>
            </MinimalLayout>
        </Route>
    );
};

export default LoginRoutes;
